<template>
  <van-collapse v-model="activeNames">
    <van-collapse-item title="标题4" name="1" class="sale-sec ele">
      <template #title>
        <div class="sec-title">
          <img src="../assets/ele/ele.png" alt="" width="32px" height="32px">
          <p class="van-ellipsis" style="color:#fff">饿了超级省(最高66元)</p>
          <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toEle('20150318020002192','poster')">领红包</van-button>
        </div>
      </template>
      <template #default>
        <div class="sec-detail">
          <p class="van-ellipsis"  style="font-size:12px">天天领红包，下单更优惠。（饿了小程序内可用）<br>红包金额各不相同，每个都领，东方不亮西方亮。</p>
          <div class="sec-btn">
            <van-grid :gutter="10" :column-num="3">
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;display:none">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline"  style="font-weight:bold;color:red">
                  <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)" @click="toEle">领券购物</van-button>
                </div>
              </div>
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                  <van-button round color="#15a5fc" @click="toggleEleHaibao">分享赚钱</van-button>
                </div>
              </div>
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                  <van-button round color="#15a5fc" @click="copyEleWenan()">复制文案</van-button>
                </div>
              </div>
            </van-grid>
          </div>
        </div>
      </template>
    </van-collapse-item>
    <van-collapse-item title="标题5" name="2" class="sale-sec ele">
      <template #title>
        <div class="sec-title">
          <img src="../assets/ele/ele.png" alt="" width="32px" height="32px">
          <p class="van-ellipsis" style="color:#fff">饿了天天领红包(大额满减券)</p>
          <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toEle('20150318020002597','poster')">领红包</van-button>
        </div>
      </template>
      <template #default>
        <div class="sec-detail">
          <p class="van-ellipsis"  style="font-size:12px">拼手速。抢饿了吗大额补贴（饿了小程序内可用）<br>红包金额各不相同，每个都领，东方不亮西方亮。</p>
          <div class="sec-btn">
            <van-grid :gutter="10" :column-num="3">
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;display:none">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline"  style="font-weight:bold;color:red">
                  <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)">领券购物</van-button>
                </div>
              </div>
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                  <van-button round color="#15a5fc" @click="toggleEleHaibao">分享赚钱</van-button>
                </div>
              </div>
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                  <van-button round color="#15a5fc" @click="copyEleWenan()">复制文案</van-button>
                </div>
              </div>
            </van-grid>
          </div>
        </div>
      </template>
    </van-collapse-item>

    <van-collapse-item title="标题6" name="3" class="sale-sec ele  mb-80">
      <template #title>
        <div class="sec-title">
          <img src="../assets/ele/ele.png" alt="" width="32px" height="32px">
          <p class="van-ellipsis" style="color:#fff">百亿补贴天天抢(最高13元补贴)</p>
          <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toEle('20150318020004284','poster')">领红包</van-button>
        </div>
      </template>
      <template #default>
        <div class="sec-detail">
          <p class="van-ellipsis"  style="font-size:12px">果蔬商超，天天抢特价（饿了小程序内可用）<br>红包金额各不相同，每个都领，东方不亮西方亮。</p>
          <div class="sec-btn">
            <van-grid :gutter="10" :column-num="3">
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;display:none">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline"  style="font-weight:bold;color:red">
                  <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)">领券购物</van-button>
                </div>
              </div>
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                  <van-button round color="#15a5fc" @click="toggleEleHaibao">分享赚钱</van-button>
                </div>
              </div>
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                  <van-button round color="#15a5fc" @click="copyEleWenan">复制文案</van-button>
                </div>
              </div>
            </van-grid>
          </div>
        </div>
      </template>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
    import {
        Button
    } from "vant";
    export default {
        components: {
            [Button.name]: Button
        },
        data() {
            return {
                activeNames: ['1','2','3']
            }
        },
        methods: {
            toEle(code, type){
                this.$emit("toEleQr", code, type)
            },

            toggleEleHaibao(){
                this.$emit("toggleEleHaibao")
            },

            copyEleWenan(){
                this.$emit("copyEleWenan")
            },

        }
    };
</script>
<style>
  @import '../assets/css/common.css';
</style>
<style type="text/css" scoped>
  .sale-sec .van-grid-item__content--surround::after {
    border-width: 0;
  }
  .sale-sec .van-grid-item__content {
    padding: 0;
  }
  .sale-sec .van-grid-item__content::after {
    border-width: 0;
  }
  .sale-sec button{
    width: 100%;
    height: 30px;
  }
  .sec-title >>> .van-button {
    width: 70px;
    padding: 0;
  }

  .sale-sec >>> .van-cell {
    background: none !important;
    padding: 0;
  }
  .sale-sec >>> .van-collapse-item__content {
    padding: 0;
  }
  .sale-sec >>> .van-icon {
    width: 26px;
    height: 26px;
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.7);
    margin-top: 11px;
    text-align: center;
    line-height: 26px;
  }
  .ele{
    background-image: -webkit-linear-gradient(to right,#15a5fc,#2f7aaa);
    background-image: -moz-linear-gradient(to right,#15a5fc,#2f7aaa);
    background-image: linear-gradient(to right,#15a5fc,#2f7aaa);
  }

</style>

